import loadable from '../../shared/utils/loadable';

// Code splitting!

const PoliciesApp = loadable(() => import('../App'));

const PoliciesHome = loadable(() => import('../components/PoliciesHome'));
const PoliciesStaticPage = loadable(() => import('../components/PoliciesStaticPage'));

const routes = [{
	path: '/policies',
	component: PoliciesApp,
	routes: [{
		path: '/policies/:type/:language',
		component: PoliciesStaticPage,
	}, {
		path: '/policies/:type',
		component: PoliciesStaticPage,
	}, {
		path: '/policies',
		component: PoliciesHome,
	}]
}];

export default routes;
